import { toastSuccess } from '@components/Toast/Toast';
import { CopyIcon, Typography } from '@gurupay/gp-ui-library';
import { MouseEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface SpecificPaymentCardItemProps {
	title: string;
	content: ReactNode;
	canCopy?: boolean;
}

export const SpecificPaymentCardItem = ({
	title,
	content,
	canCopy,
}: SpecificPaymentCardItemProps) => {
	const { t } = useTranslation();

	const handleCopy = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		navigator?.clipboard?.writeText(content as string);
		toastSuccess(t('common.successCopyToClipboard'));
	};

	const isValidCopyContent = canCopy && typeof content === 'string';

	return (
		<div className="flex justify-between sm:gap-space-8 flex-col sm:flex-row">
			<Typography className="text-neutral-600" level="small-text">
				{title}
			</Typography>

			<Typography className="font-bold capitalize sm:text-right" level="small-text">
				{content ?? '-'}

				{isValidCopyContent && (
					<button
						className="bg-transparent border-0 p-0 ml-space-4"
						onClick={handleCopy}
						type="button"
					>
						<CopyIcon
							aria-hidden="true"
							className="w-space-16 h-space-16 text-neutral-600 hover:text-neutral-800 cursor-pointer transition-all duration-300 ease-in-out"
						/>
					</button>
				)}
			</Typography>
		</div>
	);
};
